import React from "react";
import { Link } from "react-router-dom";
import { FaBars, FaUsers, FaHistory, FaBell, FaExpand, FaCopy } from "react-icons/fa";
import { MdGroupWork } from "react-icons/md";
import { IoMdPeople } from "react-icons/io";
import "./Navbar.css";

export default function Navbar({ isOpen, setIsOpen }) {
  return (
    <div className="navbar">
      {/* Left Section: Hamburger + Title */}
      <div className="navbar-left">
        <button className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
          <FaBars />
        </button>
        <Link to="/dashboard" className="nav-title">
          Admin Dashboard
        </Link>
      </div>

      {/* Right Section: Icons */}
      
    </div>
  );
}
